module.exports = __webpack_public_path__ + "img/icon-52.43a821b4.png";